export default "__VITE_ASSET__DAgwADb5__"